import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.grey[800]
      : theme.palette.grey[100],
      color: theme.palette.grey[900],
  },
}));

const WrapperApiSourceRequestCard = ({ sourceRequest, classes: dialogClasses }) => {
  const classes = useStyles();
  
  if (!sourceRequest) return null;
  
  if (!Array.isArray(sourceRequest) || sourceRequest.length === 0) return null;
  
  const sourceRequests = sourceRequest;

  return (
    <Card variant="outlined" className={classes.card}>
      <CardHeader
        title="Source Request(s)"
        avatar={<ArrowForwardIcon />}
        className={dialogClasses.logSearchDialogHeader}
      />
      <CardContent>
        <Table size="small">
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell><strong>Priority</strong></TableCell>
              <TableCell><strong>Source System</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sourceRequests.map((request, idx) => (
              <TableRow key={idx}>
                <TableCell>{request.priority || request.Priority}</TableCell>
                <TableCell>{request.sourceSystem || request.SourceSystem}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

WrapperApiSourceRequestCard.propTypes = {
  sourceRequest: PropTypes.array,
  classes: PropTypes.object.isRequired,
};

export default WrapperApiSourceRequestCard;
